<template>
  <div class="message-box" :id="tipid">
    <transition name="topfad-tip">
      <div class="message-tip" v-if="topTipWrong">
        <div class="message-tip-box"
          :class="[msgItem['type'] === 'Success' ? 'message-tip-color-success' : '', msgItem['type'] === 'Warning' ? 'message-tip-color-warning' : '', msgItem['type'] === 'Error' ? 'message-tip-color-error' : '']">
          <span class="message-tip-icon" v-if="msgItem['type']">{{ getIcon(msgItem['type']) }}</span>
          <span class="message-tip-icon" v-else>ℹ️</span>
          <p class="message-text" v-if="!msgItem['dangerouslyUseHTMLString']">{{ msgItem['message'] }}</p>
          <div class="message-text" v-else v-html="msgItem['message']"></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    msgItem: {
      type: Object
    },
    tipid: {
      type: String
    }
  },
  data() {
    return {
      topTipWrong: false,//顶部警告弹窗
    }
  },
  methods: {
    getIcon(type) {
      const iconMap = {
        'Success': '✓',
        'Error': '✕',
        'Warning': '⚠',
        'Prompt': 'ℹ'
      }
      return iconMap[type] || 'ℹ'
    },
    topTipWrongShow() {
      this.topTipWrong = true;
    },
    topTipWrongHidden() {
      this.topTipWrong = false;
      setTimeout(() => {
        let l = document.getElementById(this.tipid);
        let p = l.parentNode;
        p.removeChild(l);
      }, 800)
    },
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/allStyle";

.message-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  .message-tip {
    padding-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
   
    &-box {
      width: 40%;
      min-width: 300px;
      min-height: 50px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
      background-color: rgb(238, 242, 253);
      border: 1px solid #b6c0ca;
      color: rgb(138, 146, 157);
      display: flex;
      align-items: center;

    }

    &-color-success {
      background-color: rgb(240, 249, 235);
      border: 1px solid #c8ecb6;
      color: rgb(103, 194, 58);
    }

    &-color-error {
      background-color: rgb(254, 240, 240);
      border: 1px solid #f1dbdb;
      color: rgb(250, 115, 121);
    }

    &-color-warning {
      background-color: rgb(251, 247, 236);
      border: 1px solid #efd7bc;
      color: rgb(241, 161, 64);
    }

    &-icon {
      font-size: 18px;
      margin: 0 0 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .message-text {
      font-size: 14px;
      padding: 5px 10px;
    }
  }
}

.topfad-tip-enter-active {
  transition: all .3s;
  transform: translateY(0);
  opacity: 1
}

.topfad-tip-enter {
  transform: translateY(-100%);
  opacity: 0
}

.topfad-tip-leave-active {
  transition: all .3s;
  transform: translateY(-100%);
  opacity: 0;
}

.topfad-tip-leave {
  transform: translateY(0);
  opacity: 1
}
</style>


